export default {
	computed: {
		tagsWithMissing() {
			return this.allTags.map((name) => {
				return {
					name,
					present: this.tags.indexOf(name) >= 0,
				}
			});
		}
	}
}